import { Injectable } from '@angular/core';
import { FormBase, TextBox } from '@mapfre-design-library/src/public_api';
import { FormBaseInputsService } from '@services/common/form-base-inputs.service';

@Injectable({
  providedIn: 'root',
})
export class MakePaymentService {
  constructor(private formBaseInputsService: FormBaseInputsService) {}
  getInputs() {
    const inputs: FormBase<any>[] = [
      new TextBox({
        additionalClasses: 'form-control',
        inputType: 'text',
        key: 'makePayment_policy',
        label: 'POLICY_NUMBER_MK_PAYMENT',
        required: true,
        type: 'text',
        maxLength: 13,
        minLength: 6,
        validationMessageError: 'VALID_POLICY_VALIDATION_MESSAGE',
      }),      
      this.formBaseInputsService.getZipCodeInput(),
    ];
    return inputs;
  }
}
